import { Link } from "react-router-dom";
import { CONTACT } from "./Reveal";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-surface" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="font-display text-3xl tracking-[0.25em] font-semibold mb-4">
              LEYLAK<span className="text-accent">.</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
              {CONTACT.company} — digital marketing & business consulting for ambitious
              brands in the UK and worldwide.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-5">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail size={15} className="text-accent" />
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={15} className="text-accent" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}>{CONTACT.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-accent mt-0.5" />
                <span className="text-muted-foreground">{CONTACT.address}</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-5">
              Legal
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/privacy" data-testid="footer-privacy" className="hover:text-accent transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms" className="hover:text-accent transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/admin/login" data-testid="footer-admin" className="text-muted-foreground hover:text-accent transition-colors">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground">
          <span>© {year} {CONTACT.company}. All rights reserved.</span>
          <span>Registered in England & Wales.</span>
        </div>
      </div>
    </footer>
  );
}
